// extracted by mini-css-extract-plugin
export default {"menuCard":"homepage_menuCard__HbBTH","cardBig":"homepage_cardBig__twig5","cardSmall":"homepage_cardSmall__YnYoo"};